import * as yup from 'yup';
import { StoryCards } from '@web/components';
import { getRichTextPlainText } from '../RichText/getRichTextPlainText';
import { linkSchema, richTextFromCMSSchema } from '../schemas';
import { schema as ctaButtonSchema } from './cta_button';
import { schema as ctaGroupSchema } from './cta_group';
import { schema as storyCardSchema } from './story_card';
import { schema as starRatingSchema } from './story_cards_star_rating';

export const component = StoryCards;

const hasRichTextContent = value =>
  getRichTextPlainText(value).trim().length > 0;

export const schema = yup
  .object({
    starRating: yup.mixed().nullable(),
    headline: yup.string().required(),
    typography: yup.string(),
    fontColor: yup.string(),
    subheadline: richTextFromCMSSchema.nullable(),
    cta: yup.mixed().nullable(),
    layoutDirection: yup.string().oneOf(['content-right', 'content-left']),
    backgroundColor: yup.string(),
    cards: yup.array(storyCardSchema).min(1).required(),
  })
  .transform(value => {
    const starRatingBlok = value.star_rating?.[0];
    const ctaBlok = value.cta?.[0];

    return {
      starRating: starRatingBlok
        ? starRatingSchema.cast(starRatingBlok)
        : undefined,
      headline: value.headline,
      typography: value.typography || undefined,
      fontColor: value.font_color || undefined,
      subheadline: hasRichTextContent(value.subheadline)
        ? value.subheadline
        : undefined,
      cta: ctaBlok
        ? ctaBlok.component === 'cta_group'
          ? ctaGroupSchema.cast(ctaBlok)
          : ctaBlok.component === 'cta_button'
          ? ctaButtonSchema.cast(ctaBlok)
          : linkSchema.cast(ctaBlok)
        : undefined,
      layoutDirection: value.layout_direction || undefined,
      backgroundColor: value.background_color || undefined,
      cards: value.cards,
    };
  });
